import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from '@mui/material/DialogActions';
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";

const PAD = 4; // consistent inset on every side of the dialog

export default function CustomDialogSmall({ open, onClose, title, content, image, sources, action }) {

  const theme = useTheme();
  // background.paper defaults to MUI's stock dark value (#121212), darker
  // than the app's own dark surfaces — greydark.C800 matches the rest of
  // the dark-mode UI instead of reading as near-black.
  const bg = theme.palette.mode === "dark"
    ? theme.palette.greydark.C800
    : theme.palette.background.dialog;

  return (

    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      // MUI's default Paper elevation (24) overlays a lightening gradient in
      // dark mode on top of whatever bgcolor is set — that's what was showing
      // as a lighter "frame" around the padded edges of the dialog. elevation
      // 0 removes the overlay so the flat bgcolor actually reads flat.
      PaperProps={{ elevation: 0 }}
      aria-labelledby="custom-dialog-title"
      aria-describedby="custom-dialog-content"

      BackdropProps={{
        // 0.5 alpha wasn't dark enough to fully hide blurred page content
        // (card corners etc.) peeking through behind the dialog in dark mode.
        sx: { backdropFilter: 'blur(8px)', backgroundColor: theme.palette.mode === "dark" ? 'rgba(0,0,0,0.75)' : 'rgba(255,255,255,0.25)' },
      }}

      sx={{
        '& .MuiDialog-paper': {
          bgcolor: bg,
          borderRadius: '24px',
          position: 'relative',
        },
      }}
    >

      {/* Close button — its own row above the title, not overlapping it */}
      <Box sx={{ bgcolor: bg, display: 'flex', justifyContent: 'flex-end', px: PAD - 1, pt: PAD - 1 }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ color: theme.palette.text.secondary }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogTitle
        id="custom-dialog-title"
        sx={{
          bgcolor: bg,
          textAlign: 'left',
          pt: 0,
          pb: 1,
          px: PAD,
        }}
      >
        <Typography
          variant="h5"
          component="span" // prevents invalid <h4> inside <h2>
          sx={{
            color: theme.palette.text.primary,
            fontWeight: 600,
          }}
        >
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent
        id="custom-dialog-content"
        sx={{
          bgcolor: bg,
          px: PAD,
          pt: 1,
          pb: action ? 1 : PAD,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          textAlign: 'justify',
        }}
      >
        {content && <div>{content}</div>}

        {image && <div>{image}</div>}

        {sources && (
          <Typography
            variant="h6"
            sx={{
              fontFamily: 'Inter',
              color: theme.palette.text.secondary,
              fontWeight: 400,
            }}
          >
            {sources}
          </Typography>
        )}
      </DialogContent>

      {action && (
        <DialogActions sx={{ bgcolor: bg, px: PAD, pt: 1, pb: PAD }}>
          {action}
        </DialogActions>
      )}

    </Dialog>

  );
}
